import React from 'react';
import {BaseMixin, ElementaryMixin, SectionMixin, Tools, NestingLevelMixin} from '../common/common.js';
import Environment from '../environment/environment.js';

import './dl.less';

export const Dl = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    SectionMixin,
    NestingLevelMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Dl',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'smallBox'),
    classNames: {
      main: 'uu5-bricks-dl'
    },
    defaults: {
      childTagNames: ['UU5.Bricks.Dd', 'UU5.Bricks.Dt']
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    allowTags: React.PropTypes.arrayOf(
      React.PropTypes.string
    )
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      allowTags: []
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  shouldChildRender_: function (child) {
    var childTagName = Tools.getChildTagName(child);
    var childTagNames = this.props.allowTags.concat(this.getDefault().childTagNames);
    return childTagNames.indexOf(childTagName) > -1;
  },
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      this.getNestingLevel()
        ? (
          <dl {...this.buildMainAttrs()}>
            {this.getHeaderChild()}
            {this.getChildren()}
            {this.getFooterChild()}
            {this.getDisabledCover()}
          </dl>
        ) : null
    );
  }
  //@@viewOff:render
});

export default Dl;



// WEBPACK FOOTER //
// ./bricks/dl.js